import { InjectionToken, Injector } from '@angular/core';
import { ENVIRONMENT_PLATFORM_TOKEN, EnvironmentPlatformType } from '@campus/environment';
import { BooksTileService, BooksTileServiceInterface } from './books-tile.service';
import { KabasBooksTileService } from './books-tile.service.kabas';
import { PolpoBooksTileService } from './books-tile.service.polpo';

export const BOOKS_TILE_SERVICE_TOKEN = new InjectionToken<BooksTileServiceInterface>('BooksTileService');

export const booksTileServiceFactory = (injector: Injector, platform: EnvironmentPlatformType) => {
  if (platform === 'kabas') return new KabasBooksTileService(injector);
  if (platform === 'polpo') return new PolpoBooksTileService(injector);

  return new BooksTileService(injector);
};

export const booksTileServiceDeps = [Injector, ENVIRONMENT_PLATFORM_TOKEN];
